import React, {Component} from 'react'
import api from '../../source/api'
import {Link} from 'react-router-dom'


export default class ConfirmRegistration extends Component {

    constructor(props) {
        super(props)
        this.state = {
            token: props.location.match.params.token,
            confirmed: false,
            checkConfirmation: true
        }
        document.body.classList.toggle('loading-body', true)
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use componentDidMount instead.
     */
    componentWillMount = () => {
        let data = {
            token: this.state.token
        }
        api.post({url: 'auth/confirmregistration', data}, false).then((response) => {
            if (response.status === 200) {
                this.setState({
                    confirmed: true,
                    checkConfirmation: false
                })
                document.body.classList.remove('loading-body', true)
            }
        }).catch((err) => {
            this.setState({
                confirmed: false,
                checkConfirmation: false,
            })
            document.body.classList.remove('loading-body', true)
        })
    }


    render() {
        if (this.state.checkConfirmation) {
            return (
                <section id='cashregister-upload'>
                    <div className="min-height-500 header">
                        <h1 className="h1-title font-weight-400 text-center">Regisztráció megemerősítése folyamatban...</h1>
                    </div>
                </section>
            )
        } else if (!this.state.checkConfirmation && this.state.confirmed) {
            return (
                <section id='cashregister-upload'>
                    <div className="min-height-500 header text-center">
                        <br/>
                        <br/>
                        <h1 className="h1-title font-weight-400 text-center">Regisztráció megemrősítése sikeresen befejeződött.</h1>
                        <br/>
                        <Link className='btn green-btn' to='/login'>Bejelentkezés</Link>
                    </div>
                </section>
            )
        } else {
            return (
                <section id='cashregister-upload'>
                    <div className="min-height-500 header text-center">
                        <br/>
                        <br/>
                        <h1 className="h1-title font-weight-400 text-center">Regisztráció megemrősítése sikertelen.</h1>
                        <br/>
                        <br/>
                        <p className='font-size-15'>Kérjük vegye fel velünk a kapcsolatot a következő email: <b>info@beeker.hu </b> címen.</p>
                    </div>
                </section>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/signup/confirmregistration.js